<tam-dialog tid="note_dialog" (mousedown)="onClickSetEventValue($event)" (click)="onClickSetEventValue($event)"
    class="contact-template threaddetail-sidesheet-status" (closeminDialog)="closemin()" [titleName]="titleName"
    [opened]="opened" [dialogWidth]="dialogWidth" (keydown.esc)="onEnter($event)" (keyup)="keySend($event)"
    (containerEvent)="onContainerEvent($event)" #dialogRef>
    <ng-template #title>
        <span class="dialog-title">{{dialogOpenOptions.openType}}</span>
        <smart-icon *ngIf="false" class="dialog-min dark" name="substract" (click)="windowMinimize()"></smart-icon>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)"></smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="body-container">
            <tam-contact-navigation [config]="navigationConfig"></tam-contact-navigation>
            <div class="control-container">
                <div class="duplicated-message" *ngIf='isDuplicatedContact'>
                    <smart-icon name='exclamation-circle' class="alert-title-icon" [style.color]="iconColor">
                    </smart-icon>
                    The record you're about to create looks like a duplicate. <span class="view-dupliated"
                        (click)="viewDuplicated()">View Duplicates</span>
                </div>
                <div class="template-container"
                    [ngStyle]="{'height':isDuplicatedContact === false ? '100%' : 'calc(100% - 36px)'}">
                    <contact-template [config]="tplConfig" [valueChangeSubject]="valueChangeSubject">
                    </contact-template>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <div class="footer-container">
            <div>
                <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                    (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">Cancel</button>
                <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                    (click)="publish()"
                    [disabled]="attachmentUploading||attachmentRenaming||publishButtonHasBeenClicked||(isAutoSaving&&!editingEntryId)">Save</button>
            </div>
        </div>
    </ng-template>
</tam-dialog>